import React from 'react';
import ServiceAreas from '../../components/AdminNext/ServiceAreas';
import HeadLessLayout from '../../components/Layout/HeadLessLayout';

function action({ store }) {
  if (!store.getState().runtime.isAdminAuthenticated) return { redirect: '/login' };

  return {
    title: 'Service areas — Bas Recovery Admin',
    component: (
      <HeadLessLayout>
        <ServiceAreas />
      </HeadLessLayout>
    )
  };
}

export default action;
